'use strict';

/* 
  Rewards Tray
    this.paths.rewards.side_tray ('/member/dashboard/rewards')

  Contentful 
    EntityID: 414R13prt79cSwBceb6nOL
    SpaceID: 5s3ysw7vjfxb
    Snapshot: app/content/snapshots/master/entry-414R13prt79cSwBceb6nOL.json (was a Contentful entry, LOAN-490)
*/
function RewardsTray() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [_RewardsController];

  this.contentfulEntryId = '414R13prt79cSwBceb6nOL'; // contentType - rewards, contains list of contentype - actionPanel
  this._rewardsTrayContentModelRef = 'content.id_' + this.contentfulEntryId;
  this._totalBitcoinEarned = 0;

  var DATE_TIME_FORMAT = 'h:mma - MMM D, YYYY';
  var DATE_FORMAT = 'MMM D, YYYY';

  this.elements = {};
  this._elementClasses = {
    loadingSpinner: 'js--loading-spinner',
    rewardPanelsList: 'js--reward-panels-list',
    rewardPanelTop: 'js--reward-panel-top',
    rewardsGalleryContainerRef: 'js--rewards-gallery',
    rewardsListEmptyStateMsgRef: 'js--reward-activity__empty-state',
    rewardsList: 'js--reward-activity-table',
    rewardsListSpinner: 'js--reward-activity__spinner',
    rewardsListContainer: 'js-reward-activity__container',
    rewardListContent: 'js-reward-activity__content'
  };

  this._accountGetRewardsAction = 'account.index_rewards';
  this._accountGetRewardsCampaignsAction = 'account.get_reward_campaigns';
  this._eligiblePanels = [];
  this._eligiblePanelObj = {}; // key is contentful_id provided by backend, value is content_values provided by backend

  // Cashback Tiers:
  // Everytime business alters the rewards percentag, BE has to create a new tier to keep track of
  // whats being given out per that specific tier.
  // Currently, May 2021 we are looking for twoPercent2021 (2%) cashback tier
  this._cashbackTiersMap = {
    tier1: 1,
    tier2: 2,
    bitcoinCashback: 3,
    twoPercent2021: 4
  };

  this.init = function () {
    this._super();
    this.$node = $(this.node);

    // cache element references
    for (var className in this._elementClasses) {
      this.elements[className] = this.node.getElementsByClassName(this._elementClasses[className])[0];
    }

    // Contentful Data
    if (this.presenter.getModelProperty(this._rewardsTrayContentModelRef)) {
      this._populateRewardsTrayContent();
    } else {
      this._loadRewardsTrayContent();
    }
  };

  /* When required models are ready initPage() called 
    See: _RewardsController init() function - calls initPage() when models ready 
   */
  this.initPage = function () {
    this._$node = $(this.node);
    this._portalPresenter = document.getElementById('Portal').mogo();

    var CASHBACK_EARNED_CONTENT_KEY = 'bitcoin-cashback-monthly-earned';

    /*
      Show Reward Cashback View - this.paths.rewards.cashback ('/member/dashboard/rewards/cashback')
      Only Displayed to members that have earned cashback rewards since their last login, and have not seen before
    */

    if (!this.productSettings.hasViewedContent(CASHBACK_EARNED_CONTENT_KEY) && this.hasEarnedCashbackRewards()) {
      this.history.replaceUrl(Product.shortcutMappings[CASHBACK_EARNED_CONTENT_KEY]);
    }

    this._setComputedVariables();
    this._getRewardCampaigns(); // Eligible rewards campaigns from backend

    // Toggle dropdown when click reward activity
    this.elements.rewardsList.addEventListener('click', this._toggleTransactionItemDetail.bind(this));

    // Required when route has defer_page_load_completed: true
    this._portalPresenter.setPageLoadComplete();

    // Remove Rewards List loader, show Rewards List
    this.elements.rewardsListSpinner.addClass('hide');
    this.elements.rewardsListContainer.removeClass('hide');
    this._getRewardTotals();
  };

  // Stores the data from contentful into a model within the presenter
  // ie - this.pesenter.models.content.id_414R13prt79cSwBceb6nOL
  this._storeRewardsTrayContent = function (data) {
    if (!this.presenter.models.content) {
      this.presenter.createModel('content', {
        data: {}
      });
    }
    this.presenter.setModelProperty(this._rewardsTrayContentModelRef, data.items[0]);
  };

  this._populateRewardsTrayContent = function () {
    this.elements.header = this.node.querySelector('.js--rewards-gallery-header');
    this._contentfulLoader = new ContentfulDOMHelper(this._rewardsTrayContentModelRef, this.presenter);
    this._contentfulLoader.loadMedia(this.elements.header, { preserveAspectRatio: 'none' }, 'backgroundMediaHeader');
  };

  this._loadRewardsTrayContent = function () {
    var _this = this;

    this._contentful = new StaticContentful(_ContentfulConfiguration, $.extend({}, ContentfulAppSpaceParams, { verboseLevel: 1 }));

    this._contentful.getResource('ENTRY', { entry_id: this.contentfulEntryId }, function (data) {
      _this._storeRewardsTrayContent(data);
      _this._populateRewardsTrayContent();
    });
  };

  this._getRewardTotals = function () {
    if (this.presenter.hasAction(this._accountGetRewardsAction)) {
      this.presenter.performAction(this._accountGetRewardsAction, null, this._onGetRewardTotals.bind(this));
    } else {
      this.elements.rewardsListEmptyStateMsgRef.removeClass('hide'); // Show empty rewards state
      console.warn('cannot retrieve reward totals: missing get rewards link (' + this._accountGetRewardsAction + ')');
    }
  };

  this._onGetRewardTotals = function (data, response) {
    // Checks for Connection issue
    if (this.isGeneralConnectionIssue(data, response)) {
      this._requestErrors.rewards = response;
      if (!this._errorInitialized || this.declaredClass != this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: this._accountGetRewardsAction }, { productLabel: 'Rewards' }, null, this._connectionIssueConfig);
      }
    } else if (response === 200) {
      // Reward Total count
      var satoshiTotalCount = 0; //  initilize var, set default count;
      if (data && data.totals.sat) {
        satoshiTotalCount = data.totals.sat;
      }
      this._totalBitcoinEarned = satoshiTotalCount;
      this.node.querySelector('.amount-container__amount').innerText = this._totalBitcoinEarned;
      this._animateValue();

      // Reward Activity Section
      if (data && data.rewards) {
        this._populateRewardsActivity(data.rewards);
      }
    } else {
      console.warn('Error - Response-code: ' + response);
    }
  };

  this._animateValue = function () {
    var startValue = 0;
    var moneyElement = this.$node.find('.amount-container__amount');
    Animations.integerValue(startValue, this._totalBitcoinEarned, moneyElement);
  };

  this._getRewardCampaigns = function () {
    if (this.presenter.hasAction(this._accountGetRewardsCampaignsAction)) {
      this.presenter.performAction(this._accountGetRewardsCampaignsAction, null, this._onGetRewardCampaigns.bind(this));
    } else {
      console.warn('cannot retrieve reward campaigns: missing get rewards campaigns link');
    }
  };

  // Add rewards to the DOM
  // Taken fromo _populateFundWithdrawTransactions function inside
  // CryptoTransactionHistory.js - uses jQuery
  // Todo: Refactor to vanilla JS
  this._populateRewardsActivity = function (rewardsList) {
    // Show Empty State (No rewards to show)
    if (!rewardsList.length) this.elements.rewardsListEmptyStateMsgRef.removeClass('hide');

    var rewardList = $(this.node).find('.reward-activity-content');
    var currentReward = $('<ul class="rewards-activty-list transactions-list transaction-fund-withdraw"></ul>');
    var currentRowIndex = 0;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = rewardsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var reward = _step.value;

        var rewardObject = this.getRewardObject(reward);

        // Satoshi Conversion Template for transactions that are funded in BTC (Expanded)
        // Shows CAD Value and BTC Price
        var fundedInBTCTemplate = '\n          <div class="transaction-fund-withdraw__crypto-details transaction-fund-withdraw--column transaction-fund-withdraw--border js--fund-in-btc__cad-value hide">\n            \n            <div class="transaction-fund-withdraw__crypto-received transaction-fund-withdraw--first-column transaction-list-item__name-value">\n              <div class="transaction-list-item__field-name fund-in-btc__cad-value--label">CAD Value</div>\n              <div class="transaction-list-item__field-value fund-in-btc__cad-value--amount">$ ' + (rewardObject.valueInCad ? rewardObject.valueInCad.toFixed(2) : '') + '</div>\n            </div>\n            <div class="transaction-fund-withdraw__crypto-price transaction-fund-withdraw--second-column transaction-list-item__name-value js--fund-in-btc__btc-price hide">\n              <div class="transaction-list-item__field-name fund-in-btc__btc-price--label">BTC price</div>\n              <div class="transaction-list-item__field-value js--btc-price fund-in-btc__btc-price--amount"></div>\n            </div>\n\n          </div>';

        var rewardHeaderTemplate = '\n        <div class="transaction-list-item__header" aria-controls="fund-withdraw-detail-' + currentRowIndex + '" aria-expanded="false" role="button">\n          <div class="transaction-fund-withdraw__icon">\n            <div class="transaction-fund-withdraw__icon-indicator">\n              <svg class="svg-icon" viewbox="0 0 40 32"><use xlink:href="#' + 'icon' + '-' + 'rewards' + '"></use></svg>\n            </div>\n          </div>\n          <div class="transaction-fund-withdraw__description">\n            <div class="transaction-fund-withdraw__description-container">\n              <div class="transaction-fund-withdraw__type">' + rewardObject.campaignName + '</div>\n              <div class="transaction-fund-withdraw__date">' + rewardObject.date + '</div>\n            </div>\n            <div class="transaction-fund-withdraw__amount js--funded-amount"></div>\n          </div>\n          <div class="tooltip__arrow-up hide""></div>\n        </div>';

        // prettier-ignore TOP (un expanded)
        var row = $('\n          <li class="transaction-list-item">\n\n            ' + rewardHeaderTemplate + '\n            \n            <div class="transaction-list-item__details" id="fund-withdraw-detail-' + currentRowIndex + '">\n              <div class="transaction-fund-withdraw__date transaction-fund-withdraw--border">\n                <div class="transaction-list-item__name-value">\n                  <div class="transaction-list-item__field-name">Date</div>\n                  <div class="transaction-list-item__field-value">\n                    ' + rewardObject.dateTime + '\n                  </div>\n                </div>\n              </div>\n              <div class="transaction-fund-withdraw__funded-currency transaction-fund-withdraw--border">\n                <div class="transaction-list-item__name-value">\n                  <div class="transaction-list-item__field-name">Funded currency</div>\n                  <div class="transaction-list-item__field-value">' + (this.isFundedInBTC(rewardObject) ? 'Bitcoin (BTC)' : rewardObject.toCurrency) + '</div>\n                </div>\n              </div>\n              ' + (this.isFundedInBTC(rewardObject) ? fundedInBTCTemplate : '') + '\n\n              <div class="transaction-fund-withdraw__method-status transaction-fund-withdraw--column transaction-fund-withdraw--border">\n                <div class="transaction-fund-withdraw__method transaction-fund-withdraw--first-column transaction-list-item__name-value">\n                  <div class="transaction-list-item__field-name">Type</div>\n                  <div class="transaction-list-item__field-value">' + rewardObject.campaignName + '</div>\n                </div>\n              </div>\n\n              <div class="transaction-fund-withdraw__method-status transaction-fund-withdraw--column transaction-fund-withdraw--border">\n                <div class="transaction-fund-withdraw__status transaction-fund-withdraw--second-column transaction-list-item__name-value">\n                  <div class="transaction-list-item__field-name">Status</div>\n                  <div class="transaction-list-item__field-value"><div class="transaction-list-item__status-label">Completed</div></div>\n                </div>\n              </div>\n\n            </div>\n          </li>\n        ');
        currentRowIndex++;

        // Add in Funded Amounts into rewardHeaderTemplate
        if (this.isFundedInBTC(rewardObject)) {
          var satAmount = '';

          // Always show SAT amount if toCurrency is SAT || BTC
          if (rewardObject.toCurrency === 'BTC') {
            satAmount = rewardObject.toAmount * 100000000;
          }

          row.find('.js--funded-amount').append('\n          <div class="btc-funded-amount">\n            <span class="btc-funded-amount__value">\n              ' + (rewardObject.toCurrency === 'BTC' ? satAmount.toLocaleString() : rewardObject.toAmount.toLocaleString()) + '\n            </span>\n            <sup class="btc-funded-amount__currency">Sats</sup>\n          </div>');
        } else {
          // CAD toCurrency, show $
          row.find('.js--funded-amount').mogo().create('FormatMoney', { value: rewardObject.toAmount, animated: false });
        }

        // Show BTC Price in the Expanded accordian in BTC funded template
        if (this.isFundedInBTC(rewardObject) && rewardObject.BTCPrice) {
          row.find('.js--btc-price').mogo().create('FormatMoney', { value: rewardObject.BTCPrice, animated: false });

          // Only show if both valueInCad and BTCPrice present
          row.find('.js--fund-in-btc__cad-value').removeClass('hide');
          row.find('.js--fund-in-btc__btc-price').removeClass('hide');
        }
        currentReward.append(row);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    rewardList.append(currentReward);

    // Show section
    $('.reward-activity-content').addClass('show');
  };

  // Expand and un-expand the Accordian
  // ----------------------------------------
  // Taken from CryptoTransactionHistory.js - Todo: Refactor into re-usuable function
  // --------------------------------------
  this._toggleTransactionItemDetail = function (e) {
    if ($(e.target).closest('.transaction-list-item__header')) {
      if ($(e.target).closest('li').find('.transaction-list-item__header').attr('aria-expanded') === 'true') {
        $(e.target).closest('li').find('.transaction-list-item__details').removeClass('expanded');
        $(e.target).closest('li').find('.tooltip__arrow-up').addClass('hide');
        $(e.target).closest('li').find('.transaction-list-item__header').attr('aria-expanded', 'false');
      } else {
        $(e.target).closest('li').find('.transaction-list-item__details').addClass('expanded');
        $(e.target).closest('li').find('.tooltip__arrow-up').removeClass('hide');
        $(e.target).closest('li').find('.transaction-list-item__header').attr('aria-expanded', 'true');
      }
    }
  };

  this.isFundedInBTC = function (transactionObject) {
    return transactionObject.toCurrency === 'BTC' || transactionObject.toCurrency === 'SAT';
  };

  this.getRewardObject = function (reward) {
    var campaignName = reward.campaign.name ? reward.campaign.name : 'Rewards'; // Can be null if its null, make it Rewards by default
    var fromAmount = reward.from_amount;
    var fromCurrency = reward.from_currency;
    var toAmount = reward.to_amount;
    var toCurrency = reward.to_currency;
    var valueInCad = reward.value_in_cad;
    var dateTime = moment(reward.created_at).format(DATE_TIME_FORMAT);
    var date = moment(reward.created_at).format(DATE_FORMAT);

    var dataObj = {
      fromCurrency: fromCurrency,
      fromAmount: fromAmount,
      dateTime: dateTime,
      date: date,
      toAmount: toAmount,
      toCurrency: toCurrency,
      campaignName: campaignName
    };

    if (valueInCad) {
      var BTCFormatted = ''; // toCurrency must be BTC -> toCurrency.toFixed(8)
      var BTCPrice = '';

      if (dataObj.toCurrency === 'BTC') {
        BTCFormatted = dataObj.toAmount.toFixed(8);
      } else if (dataObj.toCurrency === 'SAT') {
        var BTCAmount = dataObj.toAmount / 100000000; // if toCurrency is not BTC and is SAT, convert SAT to BTC
        BTCFormatted = BTCAmount.toFixed(8);
      }
      BTCPrice = valueInCad / BTCFormatted; // calculate BTC price

      dataObj.valueInCad = valueInCad; // add valueInCad prop to dataObj
      dataObj.BTCPrice = BTCPrice.toFixed(2); // add BTCPrice prop to dataObj
    }
    return dataObj;
  };

  this._onGetRewardCampaigns = function (data, response) {
    // Checks for Connection issue
    if (this.isGeneralConnectionIssue(data, response)) {
      this._requestErrors.rewards = response;
      if (!this._errorInitialized || this.declaredClass != this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage({ action: this._accountGetRewardsCampaignsAction }, { productLabel: 'Rewards' }, null, this._connectionIssueConfig);
      }
    } else if (response === 200) {
      // Push all eligible panels from backend into array of objects
      for (var i = 0; i < data.reward_campaigns.length; i++) {
        var rewardPanel = data.reward_campaigns[i];
        if (rewardPanel.can_receive_benefit === true) {
          this._eligiblePanels.push(rewardPanel);
          this._eligiblePanelObj[rewardPanel.contentful_id] = rewardPanel.content_values;
        }
      }

      // For all DOM panels in Rewards Tray, if id matches eligibile Panels list (backend provided) show it
      // else hide it, also replace [ ] content inside data-content-ref="text"] with
      // corresponding object inside the back end .content_values object
      var $allPanels = this.node.getElementsByClassName('js--reward-panel-list-item');

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = $allPanels[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var panel = _step2.value;

          var panelId = panel.dataset.mogoUiContentName; // [ data-mogo-ui-content-name]

          if (this._eligiblePanelObj[panelId]) {
            // If contentID matches DOM panel id
            var panelTextNode = panel.querySelector('[data-content-ref="text"]');
            this._getAllBracketMatchesFromText(panelTextNode, this._eligiblePanelObj[panelId]);
            // Show panel
            panel.removeClass('hide');
          }
        }

        // Remove panels with hide class still on them from DOM
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var hiddenPanels = this.node.getElementsByClassName('js--reward-panel-list-item hide');
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = hiddenPanels[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _panel = _step3.value;

          _panel.remove();
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    } else {
      console.warn('Error getting rewards, Response code: ' + response);
    }
    this._showContent();
  };

  // Return all matching content inside [ ] (can be multiple)
  this._getAllBracketMatchesFromText = function (panelTextNode, eligiblePanelContentValues) {
    var panelTextNodeContent = panelTextNode.innerText;
    var parsedText = panelTextNodeContent.split('[');
    for (var j = 1; j < parsedText.length; j++) {
      var squareBracketMatch = parsedText[j].split(']')[0];
      this._replaceBracketMatchesFromPanels(squareBracketMatch, panelTextNode, eligiblePanelContentValues); // For each match, replace the content inside corresponding eligible panel
    }
  };

  this._replaceBracketMatchesFromPanels = function (squareBracketMatch, panelTextNode, eligiblePanelContentValues) {
    var panelTextNodeContent = panelTextNode.innerText;

    for (var value in eligiblePanelContentValues) {
      // loop through object, check for key matches, replace with value if key match found
      if (squareBracketMatch === value) {
        var replacedString = panelTextNodeContent.replace(squareBracketMatch, eligiblePanelContentValues[value]);
        var removeBrackets = replacedString.replace(/[\[\]']+/g, '');
        panelTextNode.textContent = removeBrackets; // Update text inside DOM panel to backend provided value
      }
    }
  };

  this._showContent = function () {
    $(this.elements.loadingSpinner).addClass('hide');
    $(this.elements.rewardsGalleryContainerRef).removeClass('hide');
  };

  this._setComputedVariables = function () {
    var _this2 = this;

    this.presenter.addComputedVariable('bitcoin_cashback_this_month_negative', ['rewards.cashback.current'], function (current) {
      return Formatters.formatMoney(current, {
        decomposeResult: true,
        separateDollarSign: true
      })[0];
    });
    this.presenter.addComputedVariable('bitcoin_cashback_this_month_dollars', ['rewards.cashback.current'], function (current) {
      return Formatters.formatMoney(current, {
        decomposeResult: true,
        separateDollarSign: true
      })[2];
    });
    this.presenter.addComputedVariable('bitcoin_cashback_this_month_cents', ['rewards.cashback.current'], function (current) {
      return '.' + Formatters.formatMoney(current, {
        decomposeResult: true,
        separateDollarSign: true
      })[3];
    });
    this.presenter.addComputedVariable('current_month_display', null, function () {
      return moment.tz('America/Vancouver').format('MMMM');
    });

    this.presenter.addComputedVariable('is_bitcoin_cashback_tier', ['rewards.cashback.active_tier_id'], function (val) {
      return val !== this._cashbackTiersMap.tier1;
    }.bind(this));

    this.presenter.addComputedVariable('has_bitcoin_cashback_unlocked', ['card.cashback.card_cashback_tiers'], function () {
      return _this2._hasBitcoinCashbackUnlocked() === true;
    });
  };

  this._hasBitcoinCashbackUnlocked = function () {
    var _this3 = this;

    var cashbackTiers = this.presenter.getModelProperty('rewards.cashback.card_cashback_tiers');
    if (typeof cashbackTiers === 'undefined') return false;

    var bitcoinCashbackTier = cashbackTiers.find(function (tier) {
      return tier.tier_id === _this3._cashbackTiersMap.twoPercent2021;
    });
    return bitcoinCashbackTier && bitcoinCashbackTier.is_eligible === true;
  };

  /*
      hasEarnedCashbackRewards 
        Checks if member has earned rewards since last login
        Note: rewards.cashback.since_last_seen is always present, and defaults values to 0 (only show if values > 0)
  */
  this.hasEarnedCashbackRewards = function () {
    var cardCashbackProp = 'rewards.cashback.since_last_seen';
    var cashbackObject = this.presenter.getModelProperty(cardCashbackProp);
    return cashbackObject && cashbackObject.sat > 0 && cashbackObject.cad > 0;
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('has_bitcoin_cashback_unlocked');
    this.presenter.removeComputedVariable('is_bitcoin_cashback_tier');
    this.presenter.removeComputedVariable('bitcoin_cashback_this_month_dollars');
    this.presenter.removeComputedVariable('bitcoin_cashback_this_month_cents');
    this.presenter.removeComputedVariable('bitcoin_cashback_this_month_negative');
    this.presenter.removeComputedVariable('current_month_display');
  };
}